import styled from 'styled-components';
import { Text12Light, Text13Bold, Text13Regular } from '../utils/Text/Text.styles';
import Skeleton from 'react-loading-skeleton';

export const MediaContainer = styled.div`
  min-width: 15rem;
  width: 15rem;
  height: 15rem;
  position: relative;
  display: flex;
  cursor: ${({ $cursor }) => $cursor && 'pointer'};

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const CloseWrapper = styled.div`
  width: 1.8rem;
  height: 1.8rem;
  position: absolute;
  top: -2px;
  right: -2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 50%;
  border: 1px solid #fff;
  background: #1672ba;
`;

export const ProgressContainer = styled.div`
  inset: 0;
  position: absolute;
  background: rgba(7, 13, 18, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
`;

export const ProgressContent = styled.div`
  width: 11rem;
  height: 11rem;
`;

export const Error = styled.div`
  position: absolute;
  inset: 0;
  background-color: #ffd6d6;
  padding: 2px 2px 4px 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
`;

export const ErrorText = styled(Text13Bold)`
  letter-spacing: -0.42px;
`;

export const ErrorText1 = styled(Text13Regular)`
  letter-spacing: -0.42px;
`;

export const ErrorMessageText = styled(Text12Light)`
  letter-spacing: -0.42px;
  opacity: 0.67;
`;

export const SkeletonContainer = styled(Skeleton)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const PlayIconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* background: rgba(0, 0, 0, 0.56); */
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
